import AddQuestionButton from "./AddQuestionButton";

export default AddQuestionButton;
